import AmexResySelector from './AmexResySelector';

export default AmexResySelector;
